import { buildEntityMarkerImages } from '../utils/entityMarkerArt';

// The exact marker images the map registers, as data URIs — built once from the same
// generator, so a design-pack change here, in the Filters panel and on the map is always
// the same pixels. Consumers size the box; object-contain keeps both marker bases
// undistorted (the taller badged markers simply render a slightly smaller pin).
const MARKER_ICON_SRC = new Map(
    buildEntityMarkerImages().map((image) => [image.id, `data:image/svg+xml,${encodeURIComponent(image.svg)}`]),
);

/**
 * A status's map marker as a small decorative inline image. `imageId` comes from
 * poiMarkerImageId / leakMarkerImageId; unknown ids render nothing rather than a broken
 * image (disabled statuses register no image, by design).
 */
export function StatusMarkerIcon({ imageId, className }: { imageId: string; className: string }) {
    const src = MARKER_ICON_SRC.get(imageId);
    if (!src) return null;
    return <img src={src} alt="" aria-hidden className={className} />;
}
